<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useAuth } from '@okta/okta-vue';
import { useRoute } from 'vue-router';
import { AppLayout } from './components/layout';
import { ToastContainer } from './components/common';
import { useAssignmentStore, useCredentialTypeStore } from '@/stores';

const $auth = useAuth();
const route = useRoute();
const assignmentStore = useAssignmentStore();
const credentialTypeStore = useCredentialTypeStore();

const isStandalonePage = computed(() => route.meta.standalone === true);

// Fetch overdue assignments and the credential-type lookup when authenticated.
// Credential types drive nav, chips, and browse filters — load once on app boot.
onMounted(async () => {
  if (await $auth.isAuthenticated()) {
    assignmentStore.fetchOverdueAssignments();
    credentialTypeStore.ensureLoaded();
  }
});
</script>

<template>
  <template v-if="isStandalonePage">
    <RouterView v-slot="{ Component }">
      <component :is="Component" :key="route.fullPath" />
    </RouterView>
  </template>
  <AppLayout v-else>
    <RouterView v-slot="{ Component }">
      <component :is="Component" :key="route.fullPath" />
    </RouterView>
  </AppLayout>
  <ToastContainer />
</template>
